import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getUserRegisteredTournamentsAPI } from '../apis/tournamentsAPI.ts';

type UserRegisteredTournaments = Awaited<
  ReturnType<typeof getUserRegisteredTournamentsAPI>
>;

type UseUserRegisteredTournamentsQueryOptions = Omit<
  UseQueryOptions<
    UserRegisteredTournaments,
    Error,
    UserRegisteredTournaments,
    ['userRegisteredTournaments']
  >,
  'queryKey' | 'queryFn'
>;

export const useUserRegisteredTournamentsAPIQuery = (
  options?: UseUserRegisteredTournamentsQueryOptions
) =>
  useQuery({
    queryKey: ['userRegisteredTournaments'],
    queryFn: () => getUserRegisteredTournamentsAPI(),
    ...options,
  });
